import { render, staticRenderFns } from "./club_events.vue?vue&type=template&id=48bd51d0"
import script from "./club_events.vue?vue&type=script&lang=js"
export * from "./club_events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports